import { Header } from "/components/Header/Header";
import { Contacts } from "/components/ContactsPage/Contacts";

export const ContactsPage = () => {
  return (
    <>
      <Header />
      <main>
        <Contacts />
      </main>
    </>
  );
};
